import React, { FC, memo } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';
import { IoMdArrowBack, IoIosList } from 'react-icons/io';

interface Props {
  title?: string;
  onBack?: () => void;
  onShowMenu?: () => void;
  doneTitle?: string;
  canBack?: boolean;
  showMenu?: boolean;
}

const Container = styled.View`
  background-color: ${Colors.MAIN_COLOR};
  min-height: 56px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-horizontal: 12px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.08);
`;

const EmptyView = styled.View`
  width: 40px;
  height: 40px;
`;

const Button = styled.TouchableOpacity`
  padding: 8px;
  min-width: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
`;

const Title = styled(Fonts.Title1)`
  font-weight: 700;
  color: ${Colors.WHITE};
  flex: 1;
  text-align: center;
  padding-horizontal: 8px;
`;

const HeaderWithTitle: FC<Props> = ({
  title,
  onBack,
  onShowMenu,
  canBack = false,
  showMenu = false,
}) => {
  return (
    <Container>
      {canBack ? (
        <Button onPress={onBack} accessibilityLabel="Quay lại">
          <IoMdArrowBack color={Colors.WHITE} size={24} />
        </Button>
      ) : (
        <EmptyView />
      )}
      <Title numberOfLines={1}>{title}</Title>
      {showMenu ? (
        <Button onPress={onShowMenu} accessibilityLabel="Danh sách câu hỏi">
          <IoIosList color={Colors.WHITE} size={24} />
        </Button>
      ) : (
        <EmptyView />
      )}
    </Container>
  );
};

export default memo(HeaderWithTitle);
